import React from 'react';
import { Col, Row } from 'react-bootstrap';
import styles from './Footer.module.scss';

export default () => (
  <div className={styles.footer}>
    <Row noGutters className={`${styles.footerRow} text-center`}>
      <Col xs={7} md={6} className='mx-auto'>
        <span>&copy; 2019 Select Medical Corporation. All Rights Reserved</span>
        <br />
        <br />
        <span>
          For any issues, please contact the IS Help Desk
          <br />
          at 1 (888) 972-1199
        </span>
      </Col>
    </Row>
  </div>
);
